import React from "react";
import { Helmet } from "react-helmet";
import SiteBreadcrumb from "../../../components/Common/Breadcumb";
import OffWrap from "../../../components/Layout/Header/OffWrap";
import Footer from "../../../components/Layout/Footer/FooterStyleOne";
import SearchModal from "../../../components/Layout/Header/SearchModal";
import ScrollToTop from "../../../components/Common/ScrollTop";
import Newsletter from "../../../components/Common/Newsletter";
import Header from "../../../components/Layout/Header/Header";
import ServiceCard from "../../../components/Service/ServiceCard";
import { Link } from "react-router-dom";
import IndustriesSection from '../../../components/IndustriesSection';
import { FaTools, FaBug, FaSyncAlt, FaDatabase, FaShieldAlt, FaChartBar, FaClock, FaLifeRing } from "react-icons/fa";

import bannerbg from "../../../assets/img/breadcrumbs/ssssss.jpg";
import Logo from "../../../assets/img/logo/dark-logo.png";
import footerLogo from "../../../assets/img/logo/lite-logo.png";
import favIcon from "../../../assets/img/fav.png";

const serviceCards = [
  {
    icon: <FaTools size={80} color="var(--brand-primary)" />,
    title: "System Updates & Patches",
    description: "Keep your software secure and up-to-date with regular updates. Prevent vulnerabilities and ensure compliance with industry standards.",
  },
  {
    icon: <FaBug size={80} color="var(--brand-primary)" />,
    title: "Bug Fixes & Troubleshooting",
    description: "Quickly resolve software bugs and issues. Minimize downtime and maintain a seamless user experience for your customers.",
  },
  {
    icon: <FaSyncAlt size={80} color="var(--brand-primary)" />,
    title: "Performance Optimization",
    description: "Enhance software speed, reliability, and scalability. Optimize code and infrastructure for peak performance.",
  },
  {
    icon: <FaDatabase size={80} color="var(--brand-primary)" />,
    title: "Database Maintenance",
    description: "Ensure data integrity and availability with regular database checks. Prevent data loss and improve query performance.",
  },
  {
    icon: <FaShieldAlt size={80} color="var(--brand-primary)" />,
    title: "Security Monitoring & Updates",
    description: "Protect your systems with proactive security monitoring. Apply the latest security patches and threat intelligence.",
  },
  {
    icon: <FaChartBar size={80} color="var(--brand-primary)" />,
    title: "System Health Monitoring",
    description: "Track software health and performance in real time. Detect issues early and maintain optimal system operation.",
  },
  {
    icon: <FaClock size={80} color="var(--brand-primary)" />,
    title: "Backup & Recovery Management",
    description: "Implement robust backup and disaster recovery plans. Safeguard your data and ensure business continuity.",
  },
  {
    icon: <FaLifeRing size={80} color="var(--brand-primary)" />,
    title: "Technical Support & Documentation",
    description: "Access expert support and clear documentation. Empower your team to resolve issues and use software effectively.",
  },
];

const SoftwareMaintenance = () => {
  return (
    <React.Fragment>
      <Helmet>
        <link rel="icon" href={favIcon} />
        <title>Software Maintenance Consultation - Syrol Tech</title>
        <meta name="description" content="Expert software maintenance consultation services. Get tailored solutions for maintaining and optimizing your software systems." />
      </Helmet>
      <OffWrap />
      <Header
        parentMenu="pages"
        secondParentMenu="others"
        headerNormalLogo={Logo}
        headerStickyLogo={Logo}
        CanvasLogo={Logo}
        mobileNormalLogo={Logo}
        CanvasClass="right_menu_togle hidden-md"
        headerClass="full-width-header header-style1 home8-style4"
        TopBar="enable"
        TopBarClass="topbar-area home8-topbar"
        emailAddress="hello@syroltech.com"
        Location="Abuja, Nigeria"
      />
      <SiteBreadcrumb
        pageTitle="Software Maintenance Consultation"
        pageName="Software Maintenance"
        breadcrumbsImg={bannerbg}
      />
      {/* Hero Section - Modern, full-width with background image and overlay */}
      <section className="consultation-hero-section position-relative w-100" style={{minHeight: '420px', display: 'flex', alignItems: 'center', justifyContent: 'center', background: `url(${bannerbg}) center/cover no-repeat`}}>
        <div className="hero-overlay" style={{position: 'absolute', inset: 0, background: 'rgba(10, 18, 32, 0.72)', zIndex: 1}}></div>
        <div className="container position-relative" style={{zIndex: 2, maxWidth: '900px', padding: '3rem 1rem', textAlign: 'left'}}>
          <h1 style={{color: '#fff', fontWeight: 700, fontSize: '2.6rem', lineHeight: 1.15, marginBottom: '1.2rem'}}>Keep Your Software Running Smoothly</h1>
          <p style={{color: '#fff', fontSize: '1.25rem', maxWidth: '600px', marginBottom: '2.2rem'}}>Ensure reliability, security, and performance with our expert software maintenance consultation. We help you optimize, update, and future-proof your systems.</p>
          <Link to="/consultation" className="readon orange-btn" style={{padding: '12px 28px', fontSize: '1rem', borderRadius: '6px', fontWeight: 700, textDecoration: 'none', display: 'inline-block', background: '#111', color: '#fff'}}>Request A Free Proposal</Link>
        </div>
      </section>
      <div className="rs-contact style1 event-bg pt-110 md-pt-10 pb-100 md-pb-80">
        <div className="container pb-66 md-pb-46">
          <h2 className="service-title mb-32">Our Software Maintenance Services</h2>
          {serviceCards.map((card, idx) => (
            <ServiceCard
              key={idx}
              icon={card.icon}
              title={card.title}
              description={card.description}
            />
          ))}
        </div>
      </div>
      <IndustriesSection />
      <Newsletter
        sectionClass="rs-newsletter style1 orange-color event-bg mb--90 sm-mb-0 sm-pb-80"
        titleClass="title mb-0 white-color"
      />
      <Footer
        footerClass="rs-footer home9-style main-home"
        footerLogo={footerLogo}
      />
      <SearchModal />
      <ScrollToTop scrollClassName="scrollup orange-color" />
    </React.Fragment>
  );
};

export default SoftwareMaintenance; 